import React from "react";
import { withTranslation } from "react-i18next";
import {
  Divider,
  FormGroup,
  FormControlLabel,
  FormControl,
  Switch,
  Checkbox,
  RadioGroup,
  Radio,
  Box,
  Slider
} from "@material-ui/core";
import {
  createTheme,
  ThemeProvider,
  withStyles
} from "@material-ui/core/styles";
import StarBorderIcon from "@material-ui/icons/StarBorder";
import { Rating } from "@material-ui/lab";
import uniqueId from "lodash/uniqueId";
import { Input } from "reactstrap";
import RecruitmentsDatePicker from "@components/arhDatePicker/recruitmentsDatePicker";
import CustomDropdown from "@components/dropdown/Dropdown";
import InputSelectFile from "@components/input/InputFile";
import { parseJsonObject } from "@helpers/_functions";
import {
  normalizeRecruitmentLinkHref,
  normalizeRecruitmentQuestionHtml
} from "@helpers/recruitmentQuestionHtml";

const arhTheme = createTheme({
  palette: {
    secondary: {
      main: "#73C7B7"
    },
    primary: {
      main: "#73C7B7"
    }
  },
  overrides: {
    MuiSwitch: {
      root: {
        marginLeft: "20px"
      }
    },
    MuiRadio: {
      root: {
        padding: 0,
        margin: "0 10px 0 20px"
      }
    },
    MuiCheckbox: {
      root: {
        padding: 0,
        margin: "0 10px 0 20px"
      }
    },
    MuiSlider: {
      thumb: {
        color: "#73C7B7"
      },
      track: {
        color: "#81dac9"
      },
      rail: {
        color: "#F9FAFC"
      }
    }
  }
});

const StyledRating = withStyles({
  iconFilled: {
    color: "#81dac9"
  },
  iconHover: {
    color: "#73C7B7"
  }
})(Rating);

const addStarsIfRequired = (question) => (question?.required ? " *" : "");

const getQuestionContentHtml = (
  question,
  fallback = "",
  includeRequired = true
) => {
  const content = question?.content;

  if (!content) return fallback;

  return normalizeRecruitmentQuestionHtml(
    `${content}${includeRequired ? addStarsIfRequired(question) : ""}`
  );
};

class ViewForm extends React.Component {
  inputSwitch = () => {
    let questionsData = this.props?.data?.questions;
    return questionsData?.length ? (
      questionsData.map((qD, qDIndex) => {
        switch (qD?.type) {
          case "Header":
            return (
              <div
                className="arh-bg-greyColor arh-py-[20px] arh-px-[40px] arh-mb-[11px] "
                dangerouslySetInnerHTML={{
                  __html: `<h3 class="arh-text-darkColor arh-text-[13px] arh-text-left arh-font-poppins arh-font-semibold ">${
                    getQuestionContentHtml(qD, this.props.t("Aucun"), false)
                  }</h3>`
                }}
              ></div>
            );
          case "Label":
            return (
              <div
                className="arh-bg-greyColor arh-py-[20px] arh-px-[40px] arh-mb-[11px] "
                dangerouslySetInnerHTML={{
                  __html: `<h3 class="arh-text-darkColor arh-text-[13px] arh-text-left arh-font-poppins arh-font-semibold ">${
                    getQuestionContentHtml(qD, this.props.t("Aucun"), false)
                  }</h3>`
                }}
              >
                {/*<h3 className="semibold">{qD.content || this.props.t("Aucun")}</h3>*/}
              </div>
            );
          case "Paragraph":
            return (
              <div
                className="arh-bg-greyColor arh-py-[20px] arh-px-[40px] arh-mb-[11px] "
                dangerouslySetInnerHTML={{
                  __html: `<p class="arh-font-poppins arh-font-medium  arh-text-left arh-text-[#636769] arh-text-[13px] ">${
                    getQuestionContentHtml(qD, this.props.t("Aucun"), false)
                  }</p>`
                }}
              >
                {/*<p className="arh-font-poppins arh-font-medium  text-left">{qD.content || this.props.t("Aucun")}</p>*/}
              </div>
            );
          case "LineBreak":
            return (
              <div className="arh-bg-greyColor arh-py-[20px] arh-px-[40px] arh-mb-[11px] ">
                <Divider />
              </div>
            );
          case "Dropdown":
            return (
              <div className="arh-bg-greyColor arh-py-[20px] arh-px-[40px] arh-mb-[11px] ">
                <div className="arh-flex arh-justify-between arh-items-center arh-mb-[13px] ">
                  <div
                    className="arh-font-poppins arh-font-medium  arh-mb-[4px] arh-text-[13px] arh-text-[#636769] arh-mt-[2rem] arh-text-left "
                    dangerouslySetInnerHTML={{
                      __html: getQuestionContentHtml(
                        qD,
                        this.props.t("Aucun")
                      )
                    }}
                  >
                    {/*qD.content + addStarsIfRequired(qD)*/}
                  </div>
                  {!this.props.isViewer ? (
                    <ThemeProvider theme={arhTheme}>
                      <FormControl component="fieldset">
                        <FormGroup aria-label="isFilterQuestion" row>
                          <FormControlLabel
                            value="isFilter"
                            control={
                              <Switch
                                size="small"
                                checked={qD.filtrage === true ? true : false}
                                disabled={
                                  this.props.maxFiltrage.length === 5 &&
                                  qD.filtrage === false
                                    ? true
                                    : false
                                }
                                onChange={() =>
                                  this.props.handleToogler(qDIndex)
                                }
                              />
                            }
                            label={this.props.t("Question de filtrage")}
                            labelPlacement="end"
                            className="arh-font-poppins arh-font-medium  text_switch"
                          />
                        </FormGroup>
                      </FormControl>
                    </ThemeProvider>
                  ) : null}
                </div>
                <div className="blackSvgColor">
                  <CustomDropdown
                    defaultText={
                      qD.content?.replace(/(<([^>]+)>)/gi, "") +
                      addStarsIfRequired(qD)
                    }
                    optionsList={qD.responses}
                    // defaultValue={this.state?.situationList?.[keysSituation]}
                    // name="situation"
                    label={(option) => `${option.text}`}
                    value={(option) => `${option.value}`}
                    // handleChange={this.handlePoste}
                    isDisabled={true}
                  />
                </div>
              </div>
            );
          case "Checkboxes":
            return (
              <div className="arh-bg-greyColor arh-py-[20px] arh-px-[40px] arh-mb-[11px] arh-flex arh-flex-col ">
                <div className="arh-flex arh-justify-between arh-items-center arh-mb-[13px] ">
                  <div
                    className="arh-font-poppins arh-font-medium  arh-mb-[4px] arh-text-[13px] arh-text-[#636769] arh-mt-[2rem] arh-text-left "
                    dangerouslySetInnerHTML={{
                      __html: getQuestionContentHtml(
                        qD,
                        this.props.t("Aucun")
                      )
                    }}
                  >
                    {/*qD.content + addStarsIfRequired(qD) || this.props.t("Aucun")*/}
                  </div>
                  {!this.props.isViewer ? (
                    <ThemeProvider theme={arhTheme}>
                      <FormControl component="fieldset">
                        <FormGroup aria-label="isFilterQuestion" row>
                          <FormControlLabel
                            value="isFilter"
                            control={
                              <Switch
                                size="small"
                                checked={qD.filtrage === true ? true : false}
                                disabled={
                                  this.props?.maxFiltrage?.length === 5 &&
                                  qD?.filtrage === false
                                    ? true
                                    : false
                                }
                                onChange={() =>
                                  this.props.handleToogler(qDIndex)
                                }
                              />
                            }
                            label={this.props.t("Question de filtrage")}
                            labelPlacement="end"
                            className="arh-font-poppins arh-font-medium  text_switch"
                          />
                        </FormGroup>
                      </FormControl>
                    </ThemeProvider>
                  ) : null}
                </div>
                <ThemeProvider theme={arhTheme}>
                  <FormControl component="fieldset">
                    <FormGroup aria-label="isFilterQuestion">
                      {qD.responses.map((qDR, index) => {
                        return (
                          <FormControlLabel
                            key={uniqueId()}
                            control={<Checkbox size="small" />}
                            label={qDR.text?.replace(/(<([^>]+)>)/gi, "")}
                            disabled
                          />
                        );
                      })}
                    </FormGroup>
                  </FormControl>
                </ThemeProvider>
              </div>
            );
          case "RadioButtons":
            return (
              <div className="arh-bg-greyColor arh-py-[20px] arh-px-[40px] arh-mb-[11px] arh-flex arh-flex-col ">
                <div className="arh-flex arh-justify-between arh-items-center arh-mb-[13px] ">
                  <div
                    className="arh-font-poppins arh-font-medium  arh-mb-[4px] arh-text-[13px] arh-text-[#636769] arh-mt-[2rem] arh-text-left "
                    dangerouslySetInnerHTML={{
                      __html: getQuestionContentHtml(
                        qD,
                        this.props.t("Aucun")
                      )
                    }}
                  >
                    {/*qD.content + addStarsIfRequired(qD) || this.props.t("Aucun")*/}
                  </div>
                  {!this.props.isViewer ? (
                    <ThemeProvider theme={arhTheme}>
                      <FormControl component="fieldset">
                        <FormGroup aria-label="isFilterQuestion" row>
                          <FormControlLabel
                            value="isFilter"
                            control={
                              <Switch
                                size="small"
                                checked={qD.filtrage === true ? true : false}
                                disabled={
                                  this.props.maxFiltrage.length === 5 &&
                                  qD.filtrage === false
                                    ? true
                                    : false
                                }
                                onChange={() =>
                                  this.props.handleToogler(qDIndex)
                                }
                              />
                            }
                            label={this.props.t("Question de filtrage")}
                            labelPlacement="end"
                            className="arh-font-poppins arh-font-medium  text_switch"
                          />
                        </FormGroup>
                      </FormControl>
                    </ThemeProvider>
                  ) : null}
                </div>
                <ThemeProvider theme={arhTheme}>
                  <FormControl component="fieldset">
                    <RadioGroup>
                      {qD.responses.map((qDR, index) => {
                        return (
                          <FormControlLabel
                            key={qDR.value}
                            value={qDR.value}
                            control={
                              <Radio
                                size="small"
                                name={qDR.value}
                                color="primary"
                                disabled
                              />
                            }
                            label={qDR.text?.replace(/(<([^>]+)>)/gi, "")}
                          />
                        );
                      })}
                    </RadioGroup>
                  </FormControl>
                </ThemeProvider>
              </div>
            );
          case "TextInput":
            return (
              <div className="arh-bg-greyColor arh-py-[20px] arh-px-[40px] arh-mb-[11px] arh-flex arh-flex-col ">
                <div className="arh-flex arh-justify-between arh-items-center arh-mb-[13px] ">
                  <div
                    className="arh-font-poppins arh-font-medium  arh-mb-[4px] arh-text-[13px] arh-text-[#636769] arh-mt-[2rem] arh-text-left "
                    dangerouslySetInnerHTML={{
                      __html: getQuestionContentHtml(
                        qD,
                        this.props.t("Aucun")
                      )
                    }}
                  >
                    {/*qD?.content + addStarsIfRequired(qD) || this.props.t("Aucun")*/}
                  </div>
                  {!this.props.isViewer ? (
                    <ThemeProvider theme={arhTheme}>
                      <FormControl component="fieldset">
                        <FormGroup aria-label="isFilterQuestion" row>
                          <FormControlLabel
                            value="isFilter"
                            control={
                              <Switch
                                size="small"
                                checked={qD.filtrage === true ? true : false}
                                disabled={
                                  this.props.maxFiltrage.length === 5 &&
                                  qD.filtrage === false
                                    ? true
                                    : false
                                }
                                onChange={() =>
                                  this.props.handleToogler(qDIndex)
                                }
                              />
                            }
                            label={this.props.t("Question de filtrage")}
                            labelPlacement="end"
                            className="arh-font-poppins arh-font-medium  text_switch"
                          />
                        </FormGroup>
                      </FormControl>
                    </ThemeProvider>
                  ) : null}
                </div>
                <div className="form_group">
                  <Input
                    type="text"
                    className="input_group  arh-font-poppins arh-font-normal "
                    placeholder={
                      qD.content?.replace(/(<([^>]+)>)/gi, "") +
                      addStarsIfRequired(qD)
                    }
                    disabled
                    // name="name"
                    // onChange={this.handleNewForm}
                    // value={'' || name}
                  />
                </div>
              </div>
            );
          case "NumberInput":
            return (
              <div className="arh-bg-greyColor arh-py-[20px] arh-px-[40px] arh-mb-[11px] arh-flex arh-flex-col">
                <div className="arh-flex arh-justify-between arh-items-center arh-mb-[13px] ">
                  <div
                    className="arh-font-poppins arh-font-medium  arh-mb-[4px] arh-text-[13px] arh-text-[#636769] arh-mt-[2rem] arh-text-left "
                    dangerouslySetInnerHTML={{
                      __html: getQuestionContentHtml(
                        qD,
                        this.props.t("Aucun")
                      )
                    }}
                  >
                    {/*qD.content + addStarsIfRequired(qD) || this.props.t("Aucun")*/}
                  </div>
                  {!this.props.isViewer ? (
                    <ThemeProvider theme={arhTheme}>
                      <FormControl component="fieldset">
                        <FormGroup aria-label="isFilterQuestion" row>
                          <FormControlLabel
                            value="isFilter"
                            control={
                              <Switch
                                size="small"
                                checked={qD.filtrage === true ? true : false}
                                disabled={
                                  this.props.maxFiltrage.length === 5 &&
                                  qD.filtrage === false
                                    ? true
                                    : false
                                }
                                onChange={() =>
                                  this.props.handleToogler(qDIndex)
                                }
                              />
                            }
                            label={this.props.t("Question de filtrage")}
                            labelPlacement="end"
                            className="arh-font-poppins arh-font-medium  text_switch"
                          />
                        </FormGroup>
                      </FormControl>
                    </ThemeProvider>
                  ) : null}
                </div>
                <div className="form_group">
                  <Input
                    type="number"
                    step="1"
                    className="input_group  arh-font-poppins arh-font-normal "
                    placeholder={
                      qD.content?.replace(/(<([^>]+)>)/gi, "") +
                      addStarsIfRequired(qD)
                    }
                    disabled
                    // name="name"
                    // onChange={this.handleNewForm}
                    // value={'' || name}
                  />
                </div>
              </div>
            );
          case "TextArea":
            return (
              <div className="arh-bg-greyColor arh-py-[20px] arh-px-[40px] arh-mb-[11px] arh-flex arh-flex-col">
                <div className="arh-flex arh-justify-between arh-items-center arh-mb-[13px] ">
                  <div
                    className="arh-font-poppins arh-font-medium  arh-mb-[4px] arh-text-[13px] arh-text-[#636769] arh-mt-[2rem] arh-text-left "
                    dangerouslySetInnerHTML={{
                      __html: getQuestionContentHtml(
                        qD,
                        this.props.t("Aucun")
                      )
                    }}
                  >
                    {/*qD.content + addStarsIfRequired(qD) || this.props.t("Aucun")*/}
                  </div>
                  {!this.props.isViewer ? (
                    <ThemeProvider theme={arhTheme}>
                      <FormControl component="fieldset">
                        <FormGroup aria-label="isFilterQuestion" row>
                          <FormControlLabel
                            value="isFilter"
                            control={
                              <Switch
                                size="small"
                                checked={qD.filtrage === true ? true : false}
                                disabled={
                                  this.props?.maxFiltrage.length === 5 &&
                                  qD.filtrage === false
                                    ? true
                                    : false
                                }
                                onChange={() =>
                                  this.props.handleToogler(qDIndex)
                                }
                              />
                            }
                            label={this.props.t("Question de filtrage")}
                            labelPlacement="end"
                            className="arh-font-poppins arh-font-medium  text_switch"
                          />
                        </FormGroup>
                      </FormControl>
                    </ThemeProvider>
                  ) : null}
                </div>
                <div className="form_group">
                  <textarea
                    className="textarea_group"
                    placeholder={
                      qD.content?.replace(/(<([^>]+)>)/gi, "") +
                        addStarsIfRequired(qD) || this.props.t("Aucun")
                    }
                    disabled
                    // name="name"
                    // onChange={this.handleNewForm}
                    // value={'' || name}
                  />
                </div>
              </div>
            );
          case "DatePicker":
            return (
              <div className="arh-bg-greyColor arh-py-[20px] arh-px-[40px] arh-mb-[11px] arh-flex arh-flex-col">
                <div className="arh-flex arh-justify-between arh-items-center arh-mb-[13px] ">
                  <div
                    className="arh-font-poppins arh-font-medium  arh-text-[13px] arh-text-[#636769] arh-text-left "
                    dangerouslySetInnerHTML={{
                      __html: getQuestionContentHtml(
                        qD,
                        this.props.t("Aucun")
                      )
                    }}
                  >
                    {/*qD?.content + addStarsIfRequired(qD) || this.props.t("Aucun")*/}
                  </div>
                  {!this.props.isViewer ? (
                    <ThemeProvider theme={arhTheme}>
                      <FormControl component="fieldset">
                        <FormGroup aria-label="isFilterQuestion" row>
                          <FormControlLabel
                            value="isFilter"
                            control={
                              <Switch
                                size="small"
                                checked={qD?.filtrage === true ? true : false}
                                disabled={
                                  this.props?.maxFiltrage.length === 5 &&
                                  qD.filtrage === false
                                    ? true
                                    : false
                                }
                                onChange={() =>
                                  this.props.handleToogler(qDIndex)
                                }
                              />
                            }
                            label={this.props.t("Question de filtrage")}
                            labelPlacement="end"
                            className="arh-font-poppins arh-font-medium  text_switch"
                          />
                        </FormGroup>
                      </FormControl>
                    </ThemeProvider>
                  ) : null}
                </div>
                <div className="arh-flex arh-flex-col datepicker_modals_parcours datepicker_vacation">
                  <RecruitmentsDatePicker
                    placeholder={
                      qD.content?.replace(/(<([^>]+)>)/gi, "") +
                      addStarsIfRequired(qD)
                    }
                    disabled={true}
                  />
                </div>
              </div>
            );
          case "Rating":
            return (
              <div className="arh-bg-greyColor arh-py-[20px] arh-px-[40px] arh-mb-[13px] arh-flex arh-flex-col">
                <div
                  className="arh-font-poppins arh-font-medium  arh-text-[13px] arh-text-[#636769] arh-text-left "
                  dangerouslySetInnerHTML={{
                    __html: getQuestionContentHtml(
                      qD,
                      this.props.t("Aucun")
                    )
                  }}
                >
                  {/*qD?.content + addStarsIfRequired(qD) || this.props.t("Aucun")*/}
                </div>

                <ThemeProvider theme={arhTheme}>
                  <Box component="fieldset" mb={3} borderColor="transparent">
                    <StyledRating
                      name="customized-empty"
                      className="arh-float-left arh-mt-[1rem] "
                      defaultValue={3}
                      precision={1}
                      emptyIcon={<StarBorderIcon fontSize="inherit" />}
                      filledIcon={<StarBorderIcon fontSize="inherit" />}
                      disabled
                    />
                  </Box>
                </ThemeProvider>
              </div>
            );
          case "HyperLink": {
            const linkHref = normalizeRecruitmentLinkHref(qD?.href);

            return (
              <div className="arh-bg-greyColor arh-py-[20px] arh-px-[40px] arh-mb-[13px] arh-flex arh-flex-col">
                <a
                  href={linkHref || undefined}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="formLink"
                  dangerouslySetInnerHTML={{
                    __html: getQuestionContentHtml(
                      qD,
                      this.props.t("Aucun"),
                      false
                    )
                  }}
                >
                  {/*qD.content*/}
                </a>
              </div>
            );
          }
          case "Range":
            let rangeConfig = parseJsonObject(qD?.rangeConfig);
            return (
              <div className="arh-bg-greyColor arh-py-[20px] arh-px-[40px] arh-mb-[13px] arh-flex arh-flex-col">
                <div
                  className="arh-font-poppins arh-font-medium  arh-text-[13px] arh-text-[#636769] arh-text-left "
                  dangerouslySetInnerHTML={{
                    __html: getQuestionContentHtml(
                      qD,
                      this.props.t("Aucun")
                    )
                  }}
                >
                  {/*qD?.content + addStarsIfRequired(qD) || this.props.t("Aucun")*/}
                </div>
                <div className="arh-w-full arh-rate-formulaire ">
                  <ThemeProvider theme={arhTheme}>
                    <Slider
                      defaultValue={rangeConfig?.defaultValue}
                      // getAriaValueText={valuetext}
                      aria-labelledby="discrete-slider-always"
                      step={rangeConfig?.step}
                      marks={rangeConfig?.marks}
                      min={rangeConfig?.marks?.[0]?.value || 0}
                      max={rangeConfig?.marks?.[1]?.value | 20}
                      valueLabelDisplay="auto"
                      disabled
                    />
                  </ThemeProvider>
                </div>
              </div>
            );
          case "Camera":
            return (
              <div className="arh-bg-greyColor arh-py-[20px] arh-px-[40px] arh-mb-[13px] arh-flex arh-flex-col">
                <InputSelectFile disabled={true} />
              </div>
            );
          default:
            return null;
        }
      })
    ) : (
      <div className="no_data">{this.props.t("Aucune question")}</div>
    );
  };

  render() {
    return (
      <div className="arh-mt-[25px]">
        <div className="arh-w-full arh-p-[26px] arh-mb-[61px] arh-bg-[#fafafa]">
          <div className="arh-flex arh-justify-between thirdDefault">
            <div className="arh-w-[31%] arh-mb-[11px] arh-flex arh-flex-col  form_group">
              <div className="arh-font-poppins arh-font-medium  arh-mb-[4px] arh-text-[13px] arh-text-[#636769] arh-mt-[2rem] arh-text-left ">
                {this.props.t("Nom *")}
              </div>
              <Input
                className="input_group  arh-font-poppins arh-font-normal "
                placeholder={this.props.t("Nom")}
                disabled
              />
            </div>
            <div className="arh-w-[31%] arh-mb-[11px] arh-flex arh-flex-col  form_group">
              <div className="arh-font-poppins arh-font-medium  arh-mb-[4px] arh-text-[13px] arh-text-[#636769] arh-mt-[2rem] arh-text-left ">
                {this.props.t("Prénom *")}
              </div>
              <Input
                className="input_group  arh-font-poppins arh-font-normal "
                placeholder={this.props.t("Prénom")}
                disabled
              />
            </div>
            <div className="arh-w-[31%] arh-mb-[11px] arh-flex arh-flex-col  form_group">
              <div className="arh-font-poppins arh-font-medium  arh-mb-[4px] arh-text-[13px] arh-text-[#636769] arh-mt-[2rem] arh-text-left ">
                {this.props.t("Courriel *")}
              </div>
              <Input
                className="input_group  arh-font-poppins arh-font-normal "
                placeholder={this.props.t("Courriel")}
                disabled
              />
            </div>
            
            {/* <div className="d-flex flex-align-end secondInput">
              <div className=" arh-font-poppins arh-font-normal  d-flex flex-justify-center flex-align-center downloadCV">
                {SvgUploadCV()}
                <span className="labelDownload arh-font-poppins arh-font-medium ">
                  Télécharger mon CV
                </span>
              </div>
            </div> */}
          </div>
          <div className="arh-flex arh-justify-between arh-flex-wrap thirdDefault">
            <div className="arh-w-[31%] arh-mb-[11px] arh-flex arh-flex-col  form_group">
              <div className="arh-font-poppins arh-font-medium  arh-mb-[4px] arh-text-[13px] arh-text-[#636769] arh-mt-[2rem] arh-text-left ">
                {this.props.t("Téléphone ")}
              </div>
              <Input
                className="input_group  arh-font-poppins arh-font-normal "
                placeholder={this.props.t("Téléphone")}
                disabled
              />
            </div>

            <div className="arh-w-[31%] arh-mb-[11px] arh-flex arh-flex-col  form_group">
              <div className="arh-font-poppins arh-font-medium  arh-mb-[4px] arh-text-[13px] arh-text-[#636769] arh-mt-[2rem] arh-text-left ">
                {this.props.t("Adresse ")}
              </div>
              <Input
                className="input_group  arh-font-poppins arh-font-normal "
                placeholder={this.props.t("Adresse")}
                disabled
              />
            </div>

            <div className="arh-w-[31%] arh-mb-[11px] arh-flex arh-flex-col  form_group">
              <div className="arh-font-poppins arh-font-medium  arh-mb-[4px] arh-text-[13px] arh-text-[#636769] arh-mt-[2rem] arh-text-left ">
                {this.props.t("Adresse complémentaire")}
              </div>
              <Input
                className="input_group  arh-font-poppins arh-font-normal "
                placeholder={this.props.t("Adresse complémentaire")}
                disabled
              />
            </div>
            {/* <div className="arh-w-[23%] arh-mb-[11px] arh-flex arh-flex-col  form_group">
              <div className="arh-font-poppins arh-font-medium  arh-mb-[4px] arh-text-[13px] arh-text-[#636769] arh-mt-[2rem] arh-text-left ">
                {this.props.t("Ville ")}
              </div>
              <Input
                className="input_group  arh-font-poppins arh-font-normal "
                placeholder={this.props.t("Ville")}
                disabled
              />
            </div>
            <div className="arh-w-[23%] arh-mb-[11px] arh-flex arh-flex-col  form_group">
              <div className="arh-font-poppins arh-font-medium  arh-mb-[4px] arh-text-[13px] arh-text-[#636769] arh-mt-[2rem] arh-text-left ">
                {this.props.t("Code Postale ")}
              </div>
              <Input
                className="input_group  arh-font-poppins arh-font-normal "
                placeholder={this.props.t("Code Postale")}
                disabled
              />
            </div>
            <div className="arh-w-[23%] arh-mb-[11px] arh-flex arh-flex-col  form_group">
              <div className="arh-font-poppins arh-font-medium  arh-mb-[4px] arh-text-[13px] arh-text-[#636769] arh-mt-[2rem] arh-text-left ">
                {this.props.t("Province ")}
              </div>
              <Input
                className="input_group  arh-font-poppins arh-font-normal "
                placeholder={this.props.t("Province")}
                disabled
              />
            </div> */}
          </div>
        </div>
        <div>{this.inputSwitch()}</div>
      </div>
    );
  }
}
export default withTranslation("pages.recruitments.ApplicationsForms.viewForm")(
  ViewForm
);
